<template>
  <section>
    <report-filter-bar
      v-model="filter"
      :preset="preset"
      :busy="isAnyLoading"
      :compare-label="compareLabel"
      :show-paid-only="false"
      @preset="applyPreset"
      @change="refresh"
      @refresh="refresh"
    />

    <b-row class="match-height">
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-chart
          :series="trend"
          title="روند سرنخ‌ها"
          subtitle="وضعیت هر سرنخ در لحظه‌ی گزارش لحاظ می‌شود، نه وضعیتش در همان روز"
          :metrics="['leads', 'contacted', 'won', 'lost']"
          type="bar"
          :height="310"
          :loading="loading('trend')"
          :skin="skin"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-chart
          :series="trend"
          title="نرخ تبدیل"
          subtitle="نسبت سرنخ‌های موفق به کل سرنخ‌های هر بازه"
          :metrics="['rate']"
          type="line"
          :height="260"
          :loading="loading('trend')"
          :skin="skin"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="7"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="bySource"
          title="منبع سرنخ"
          subtitle="ستون «پیگیری‌نشده» سرنخ‌هایی است که هنوز در وضعیت جدید مانده‌اند"
          label-title="منبع"
          :loading="loading('bySource')"
        />
      </b-col>

      <b-col
        lg="5"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="byStatus"
          title="وضعیت پیگیری"
          :subtitle="rangeLabel"
          label-title="وضعیت"
          :loading="loading('byStatus')"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card no-body>
          <b-card-body class="d-flex align-items-center justify-content-between flex-wrap">
            <div>
              <h5 class="mb-25">
                پیگیری تک‌به‌تک
              </h5>
              <span class="text-muted small">برای تماس و تغییر وضعیت، به فهرست سرنخ‌ها بروید</span>
            </div>
            <b-button
              variant="outline-primary"
              size="sm"
              @click="$router.push({ name: 'lead' })"
            >
              <feather-icon
                icon="ExternalLinkIcon"
                size="14"
              />
              <span class="ml-25">فهرست سرنخ‌ها</span>
            </b-button>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BCardBody } from 'bootstrap-vue'
import reportMixin from '@core/mixins/report'

export default {
  name: 'ReportLeads',
  components: { BCardBody },
  mixins: [reportMixin],
  data() {
    return {
      trend: null,
      bySource: null,
      byStatus: null,
    }
  },
  computed: {
    compareLabel() {
      return this.trend && this.trend.CompareRange ? this.trend.CompareRange.Label : null
    },
  },
  created() {
    this.filter.PaidOnly = false
    this.refresh()
  },
  methods: {
    refresh() {
      const api = this.$api.report

      this.fetchReport('trend', api.leadTrend)
      this.fetchReport('bySource', api.leadBySource)
      this.fetchReport('byStatus', api.leadByStatus)
    },
  },
}
</script>
